export * from './HandThumbRightIcon'
